import { Component, Input, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { IconComponent } from '../../shared/icon/icon.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatList, MatListItem, MatNavList } from '@angular/material/list';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { RoleEnum } from '../../../enum/role.enum';
import { selectRole } from '../../../store/profile/profile.state';
import { MatButton, MatFabButton } from '@angular/material/button';
import { FabExpandComponent } from '../fab-expand/fab-expand.component';
import { FabMenuComponent } from '../fab-menu/fab-menu.component';
import { CreateEntityButtonComponent } from '../create-entity-button/create-entity-button.component';

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    imports: [ MatListItem, RouterLink, IconComponent, RouterLinkActive, AsyncPipe, MatNavList, MatButton, MatList, FabExpandComponent, MatFabButton, FabMenuComponent, CreateEntityButtonComponent ]
})
export class SideMenuComponent implements OnInit {

    @Input()
    public open = false;

    constructor(private store: Store<AppState>, private breakpointObserver: BreakpointObserver) {
    }

    wideMode$: Observable<boolean> = this.breakpointObserver.observe([ Breakpoints.Large, Breakpoints.Handset ])
        .pipe(
            map((result) => result.matches),
            shareReplay()
        );

    public showInvoices$ = this.store.select(selectRole(RoleEnum.VIEW_TRANSACTIONS));
    public showAddresses$ = this.store.select(selectRole(RoleEnum.VIEW_ADDRESS_BOOKS));
    public showLibrary$ = this.store.select(selectRole(RoleEnum.PACKAGE_LIBRARY));

    ngOnInit(): void {
    }

}
